import { render, staticRenderFns } from "./RecoverUserPassword.vue?vue&type=template&id=10c59107"
import script from "./RecoverUserPassword.vue?vue&type=script&lang=js"
export * from "./RecoverUserPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports